module.exports = __webpack_public_path__ + "static/media/tuvalu.1f5f243e.svg";